import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { ProductsList } from "../constants/products";
import CardProduct from "../components/Products/cardProduct";

export default function ProductsMainPage() {
    const [prod, setProd] = useState(true)
    useEffect(() => {
        document.title = 'Turtton - Наши продукты';
    }, [])
    return (
        <div className="w-[94%] mx-auto bg-white pt-16 lg:pt-20 2xl:pt-28">
            <div className="flex gap-[3%]">
                <button onClick={() => setProd(true)} className={`font-play font-bold text-[25px] lg:text-[42px] 2xl:text-[48px] leading-[28px] lg:leading-[45px] 2xl:leading-[50px] mb-[2%] ${prod ? 'text-[#38B945]' : 'text-[#273167]'} transition-all duration-300 `}>Наша продукция</button>
                <button onClick={() => setProd(false)} className={`font-play font-bold text-[25px] lg:text-[42px] 2xl:text-[48px] leading-[28px] lg:leading-[45px] 2xl:leading-[50px] mb-[2%] ${!prod ? 'text-[#38B945]' : 'text-[#273167]'} transition-all duration-300 `}>Дистрибуция</button>
            </div>
            <div className="w-[100%] mx-auto grid grid-cols-2  sm:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-y-5 lg:gap-x-[2%] 2xl:gap-y-7 2xl:gap-x-[2%] mt-4 lg:mt-8 2xl:mt-12 mb-5 lg:mb-6 2xl:mb-8 relative">
                {ProductsList.map((card, index) => (
                    <AnimatedCard
                        key={index}
                        srcImage={card.srcImage}
                        title={card.title}
                        text={card.text}
                        link={card.link}
                    />
                ))}
            </div>
        </div>
    )
}

interface CardServiceProps {
    srcImage: string;
    title: string;
    text: string;
    link: string;
}


function AnimatedCard({ srcImage, title, text,link }: CardServiceProps) {
    const { ref, inView } = useInView({
        triggerOnce: true, // Анимация срабатывает только один раз
        threshold: 0.7, // Срабатывание анимации, когда 70% элемента видно
    });

    return (
        <div
            ref={ref}
            className={`transition-all duration-[1500ms] ${inView ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-16"
                }`}
        >
            <CardProduct
                srcImage={srcImage}
                title={title}
                text={text}
                link={link}
            />
        </div>
    );
}